import ApisService from './index'
import { ISupplier, ISupplierImport } from '../interfaces/supplierInterfaces'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'

export function createSupplier(data: ISupplier) {
  try {
    return ApisService.post('/nhacungcap/create-nhacungcap', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updateSupplier(data: ISupplier) {
  try {
    return ApisService.put('/nhacungcap/' + data.id + '/update-nhacungcap', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getDetailSupplier(id: string) {
  try {
    return ApisService.get('/nhacungcap/' + id + '/get-chitiet-nhacungcap')
  } catch (err) {
    handleError(err)
    throw err
  }
}


export function getListSupplier(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/nhacungcap/filter-nhacungcap', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteSupplier(id: string) {
  try {
    return ApisService.delete('/nhacungcap/' + id + '/delete-nhacungcap')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteMultiSupplier(idArr: Array<string>) {
  try {
    return ApisService.delete('/nhacungcap/bulk-delete-nhacungcap', { data: idArr })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function importSupplier(data: Array<ISupplierImport>) {
  try {
    return ApisService.post('/nhacungcap/import-nhacungcap', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}